import { Box } from '@chakra-ui/react';
import BrushStrokes from 'images/backgrounds/brush-stroke.png';
import Image from 'next/image';

export const ChartBackground = () => {
  return (
    <>
      <Box position="absolute" top="45px" right={{ base: '-1200px', xl: '-800px' }} width="1635px" zIndex={-1}>
        <Image
          src={BrushStrokes}
          alt="background"
          style={{
            objectFit: 'cover',
            width: '100%',
            height: 'auto',
          }}
        />
      </Box>

      <Box
        position="absolute"
        top={{ base: '500px', xl: '500px' }}
        left={{ base: '-1200px', xl: '-600px' }}
        width="1625px"
        zIndex={-1}
      >
        <Image
          src={BrushStrokes}
          alt="background"
          style={{
            objectFit: 'cover',
            width: '100%',
            height: 'auto',
          }}
        />
      </Box>
    </>
  );
};
